var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAiEnhancedArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 55,
  height: 150,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M50.648 98.737c-3.98 3.511-8.575 7.827-14.63 12.134C19.269 94.581 2.709 28.923 54.41.424-7.856 18.694-1.736 89.112 8.788 108.95c1.92 3.618 8.604 13.784 8.604 13.784L.745 131.892s35.067 12.592 48.894 17.321c-.547-20.47.163-44.268 1.01-50.476Z",
  fill: "#DBEAFE"
})));
export default SvgAiEnhancedArrow;